const convertToOrderUrl = (
  countryCode: string,
  storeId: string | null,
  code: string | null,
  checkoutId: string | null,
) => {
  const origin = window.location.origin;
  const prefix = `${origin}/${countryCode}/order`;

  if (storeId) return `${prefix}?store_id=${storeId}`;
  if (code) return `${prefix}?order_campaign_referred_code=${code}`;
  if (checkoutId) return `${prefix}?checkout_id=${checkoutId}`;

  return null;
};

export default convertToOrderUrl;
